<script setup>
// A Nexus Neural dentro do modo TV: o mesmo motor da tela própria
// (../teia/motor.js), sem os painéis, recebendo os eventos da IA ao vivo.
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { criaMotor } from '../teia/motor';
import { createNexusApi } from '../nexus/api';

const props = defineProps({
  accountId: { type: [Number, String], required: true },
});

const LEITURA = 4000;
const tela = ref(null);
let motor = null;
let cursor = null;
let relogio = null;

const leEventos = async () => {
  if (!motor || document.hidden) return;
  try {
    const { data } = await createNexusApi(props.accountId).eventosDaTeia(cursor);
    cursor = data.cursor;
    const primeiro = data.eventos[0]?.em || 0;
    data.eventos.forEach(evento => {
      const atraso = Math.min(LEITURA - 500, Math.max(0, evento.em - primeiro));
      motor.toca(evento, atraso + Math.random() * 300, () => {});
    });
  } catch {
    // Tenta de novo na próxima leitura.
  }
};

onMounted(async () => {
  try {
    const { data } = await createNexusApi(props.accountId).teia();
    if (!tela.value || !data.agentes?.length) return;
    cursor = data.cursor;
    motor = criaMotor(tela.value, { zoomInicial: 1 });
    motor.monta(data);
    motor.numeros(data.numeros);
    motor.modoTv?.(true);
    relogio = setInterval(leEventos, LEITURA);
  } catch {
    // Sem a teia (empresa sem IA), a vista fica vazia.
  }
});

onBeforeUnmount(() => {
  clearInterval(relogio);
  motor?.destroi();
});
</script>

<template>
  <canvas ref="tela" class="block w-full h-full" />
</template>
